import { store } from "../store";
import Echo from "laravel-echo";
import axios from "axios";
import keyBy from "lodash/keyBy";

export function newMessageMapped(data) {
  return {
    ...data,
    sender: {
      ...data.sender,
      avatar: data.sender.avatar
        ? data.sender.avatar
        : store.get("app/userAvatarColor")
    },
    me: data.sender.id === store.get("auth/user@id")
  };
}

export function listenChatRoom(
  echo,
  roomId,
  { onMessageReceived, onRoomDeleted, onRoomRenamed, onRoomCompleteCase }
) {
  if (roomId && echo && echo instanceof Echo) {
    leaveChatRoom(echo, roomId);
    const obj = echo.join(`room.${roomId}`);
    if (typeof onMessageReceived === "function") {
      obj.listen(".message.received", ({ data }) => {
        onMessageReceived(newMessageMapped(data), data.room_id);
      });
    }
    if (typeof onRoomDeleted === "function") {
      obj.listen(".room.deleted", ({ data }) => {
        onRoomDeleted(data);
      });
    }
    if (typeof onRoomRenamed === "function") {
      obj.listen(".room.renamed", ({ data }) => {
        onRoomRenamed(data);
      });
    }
    if (typeof onRoomCompleteCase === "function") {
      obj.listen(".room.complete", ({ data }) => {
        onRoomCompleteCase(data);
      });
    }
  }
}

export function leaveChatRoom(echo, roomId) {
  if (roomId && echo && echo instanceof Echo) {
    echo.leave(`room.${roomId}`);
  }
}

export function listenSubChannel(echo, subChannelId, { onNewRoom }) {
  if (subChannelId && echo && echo instanceof Echo) {
    leaveSubChannel(echo, subChannelId);
    const obj = echo.join(`subChannel.${subChannelId}`);
    if (typeof onNewRoom === "function") {
      obj.listen(".new.room", ({ data }) => {
        onNewRoom(data);
      });
    }
  }
}

export function leaveSubChannel(echo, subChannelId) {
  if (subChannelId && echo && echo instanceof Echo) {
    echo.leave(`subChannel.${subChannelId}`);
  }
}

export function fetchChannels(forSheet = null, channelId = null) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        forSheet && channelId
          ? `me/channels?forSheet=${forSheet}&id=${channelId}`
          : `me/channels`
      )
      .then(res => {
        const channels = [...res.data.data];
        resolve(channels);
      })
      .catch(err => reject(err));
  });
}

export function fetchSubChannels(channelId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`me/channels/${channelId}/sub-channels`)
      .then(res => {
        const channels = [...res.data.data];
        resolve(channels);
      })
      .catch(err => reject(err));
  });
}

export function fetchRooms(channelId, subChannelId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`me/channels/${channelId}/sub-channels/${subChannelId}/rooms`)
      .then(res => {
        const rooms = [...res.data.data];
        resolve(rooms);
      })
      .catch(err => reject(err));
  });
}

export function fetchConversations(roomId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`me/rooms/${roomId}/conversations`)
      .then(res => {
        const conversations = [...res.data.data].map(item =>
          newMessageMapped(item)
        );
        resolve(conversations);
      })
      .catch(err => reject(err));
  });
}

export function markAsRead(roomId) {
  return new Promise((resolve, reject) => {
    axios
      .post(`me/rooms/${roomId}/read`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => reject(err));
  });
}

export function deleteRoom(roomId, socketId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`rooms/${roomId}`, {
        headers: {
          "X-Socket-ID": socketId ? "" : socketId
        }
      })
      .then(res => {
        resolve(res.data.data);
      })
      .catch(err => reject(err));
  });
}

export function renameRoom(roomId, data, socketId) {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `rooms/${roomId}`,
        {
          ...data
        },
        {
          headers: {
            "X-Socket-ID": socketId ? "" : socketId
          }
        }
      )
      .then(res => {
        resolve(res.data.data);
      })
      .catch(err => reject(err));
  });
}

export function completeCase(roomId, socketId) {
  return new Promise((resolve, reject) => {
    axios
      .patch(`rooms/${roomId}/complete-case`, null, {
        headers: {
          "X-Socket-ID": socketId ? "" : socketId
        }
      })
      .then(res => {
        resolve(res.data.data);
      })
      .catch(err => reject(err));
  });
}

export function channelsToEntities(channels) {
  const rooms = [];
  channels
    .map(c =>
      c.sub_channels.map(sc =>
        sc.rooms.map(r => ({
          ...r,
          channelId: c.id,
          subChannelId: sc.id
        }))
      )
    )
    .forEach(c => c.forEach(sc => sc.forEach(r => rooms.push(r))));
  return keyBy(rooms, r => `${r.channelId}-${r.subChannelId}-${r.id}`);
}
